var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.isShowSettings)?_c('Settings',{on:{"close":_vm.closeSettings}}):_vm._e(),_c('GameContainer',{on:{"settings":function($event){_vm.isShowSettings = true}}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }